// 会议
export const meetingRoomPages = {
	pages: {
		id: "meeting",
		text: "会务系统",
		icon: "Extension",
	},
	dashboard: {
		id: "dashboard",
		text: "仪表盘",
		path: "/meeting/dashboard/",
		icon: "Home",
		subMenu: null,
	},
	bookingManagement: {
		id: "bookingManagement",
		text: "预约管理",
		path: "meeting/bookingManagement",
		icon: "Article",
		subMenu: {
			appointmentMeeting: {
				id: "appointmentMeeting",
				text: "预约会议",
				path: "meeting/bookingManagement/appointment-meeting",
				icon: "EditCalendar",
				notification: true,
			},
			myMeeting: {
				id: "myMeeting",
				text: "我的会议",
				path: "meeting/bookingManagement/my-meeting",
				icon: "AccessAlarm",
			},
			meetingManagement: {
				id: "meetingManagement",
				text: "会议管理",
				path: "meeting/bookingManagement/meeting-management",
				icon: "FileCopy",
			},
			meetingReview: {
				id: "meetingReview",
				text: "会议审核",
				path: "meeting/bookingManagement/meeting-review",
				icon: "FactCheck",
			},
		}
	},
	meetingStatementManagement: {
		id: "meetingStatementManagement",
		text: "会议纪要管理",
		path: "meeting/meetingStatement",
		icon: "ViewArray",
	},
	meetingSignManagement: {
		id: "meetingSignManagement",
		text: "会议签到管理",
		path: "meeting/meetingSignature",
		icon: "ViewArray",
	},
	meetingRoomManagement: {
		id: "meetingRoomManagement",
		text: "会议室管理",
		path: "meeting/meetingRoomManagement",
		icon: "Roofing",
		subMenu: {
			regionalManagement: {
				id: "regionalManagement",
				text: "会议室区域管理",
				path: "meeting/meetingRoomManagement/regional-management",
				icon: "Storefront",
			},
			roomManagement: {
				id: "roomManagement",
				text: "会议室管理",
				path: "meeting/meetingRoomManagement/room-management",
				icon: "Store",
			},
			personnelPreposition: {
				id: 'personnelPreposition',
				text: '会议人员预设',
				path: 'meeting/meetingRoomManagement/personnel-preposition',
				icon: 'ViewArray',
			},
			// tabletTemplate: {
			// 	id: "tabletTemplate",
			// 	text: "显示模板管理",
			// 	path: "meeting/meetingRoomManagement/tablet-template",
			// 	icon: "ViewArray",
			// 	hide: true,
			// },
			productsGrid: {
				id: "productsGrid",
				text: "显示模板管理",
				path: "meeting/meetingRoomManagement/grid",
				icon: "CalendarViewMonth",
			},
			productID: {
				id: "productID",
				text: "显示模板",
				path: "meeting/meetingRoomManagement/product",
				hide: true,
			},
			productID2: {
				id: "productID2",
				text: "显示模板",
				path: "meeting/meetingRoomManagement/product2",
				hide: true,
			},
			inkscreenManagement: {
				id: "inkscreenManagement",
				text: "墨水屏设备管理",
				path: "meeting/meetingRoomManagement/inkscreenManagement",
				icon: "SmartScreen",
			},
			inkscreenTemplateManagement: {
				id: "inkscreenTemplateManagement",
				text: "墨水屏模板管理",
				path: "meeting/meetingRoomManagement/inkscreenTemplateManagement",
				icon: "ViewArray",
			},
			inkscreenTemplateAdd: {
				id: "inkscreenTemplateAdd",
				text: "添加墨水屏模板",
				path: "meeting/meetingRoomManagement/inkscreenTemplateAdd",
				hide: true,
			},
			inkscreenTemplateEdit: {
				id: "inkscreenTemplateEdit",
				text: "编辑墨水屏模板",
				path: "meeting/meetingRoomManagement/inkscreenTemplateEdit",
				hide: true,
			},
		}
	},
	equipmentManagement: {
		id: "equipmentManagement",
		text: "设备资产管理",
		path: "meeting/equipmentManagement",
		icon: "Article",
		subMenu: {
			equipmentList: {
				id: "equipmentList",
				text: "设备列表",
				path: "meeting/equipmentManagement/equipment-list",
				icon: "ViewArray",
			},
			// equipmentGroupList: {
			// 	id: "equipmentGroupList",
			// 	text: "设备组列表",
			// 	path: "meeting/equipmentManagement/equipment-group-list",
			// 	icon: "ViewArray",
			// },
			equipmentTypeList: {
				id: "equipmentTypeList",
				text: "设备类型",
				path: "meeting/equipmentManagement/equipment-type-list",
				icon: "ViewArray",
			},
		}
	},
	systemManagement: {
		id: "systemManagement",
		text: "系统管理",
		path: "meeting/systemManagement",
		icon: "Radio",
		subMenu: {
			userManagement: {
				id: "userManagement",
				text: "用户管理",
				path: "meeting/systemManagement/user-management",
				icon: "Group",
			},
			roleManagement: {
				id: "roleManagement",
				text: "角色管理",
				path: "meeting/systemManagement/role-management",
				icon: "SafetyDivider",
			},
			menuManagement: {
				id: "menuManagement",
				text: "菜单管理",
				path: "meeting/systemManagement/menu-management",
				icon: "Rule",
			},
			configurationManagement: {
				id: "configurationManagement",
				text: "配置管理",
				path: "meeting/systemManagement/configuration-management",
				icon: "Handyman",
			},
			divisionalManagement: {
				id: "divisionalManagement",
				text: "部门管理",
				path: "meeting/systemManagement/divisional-management",
				icon: "Schema",
			},
			organizationManagement: {
				id: "organizationManagement",
				text: "组织管理",
				path: "meeting/systemManagement/organization-management",
				icon: "Podcasts",
				//hide: true,
            }
		}
	},
	statementManagement: {
		id: "statementManagement",
		text: "报表管理",
		path: "meeting/statementManagement",
		icon: "Storage",
		subMenu: {
			meetingStatement: {
				id: "meetingStatement",
				text: "会议报表",
				path: "meeting/statementManagement/meeting-statement",
				icon: "Tune",
			},
			meetingSignature: {
				id: "meetingSignature",
				text: "会议签到",
				path: "meeting/statementManagement/meeting-signature",
				icon: "WavingHand",
			},
			meetingQuestionnaire: {
				id: "meetingQuestionnaire",
				text: "会议问卷",
				path: "meeting/statementManagement/meeting-questionnaire",
				icon: "ViewArray",
			},
			meetingInvitation: {
				id: "meetingInvitation",
				text: "会议邀请",
				path: "meeting/statementManagement/meeting-invitation",
				icon: "ViewArray",
			},
			meetingVideo: {
				id: "meetingVideo",
				text: "视频会议报表",
				path: "meeting/statementManagement/meeting-video",
				icon: "Tune",
			},
		}
	},
	logManagement: {
		id: "logManagement",
		text: "日志管理",
		path: "meeting/logManagement",
		icon: "Summarize",
		subMenu: {
			actionLog: {
				id: "actionLog",
				text: "行为日志",
				path: "meeting/logManagement/action-log",
				icon: "Subtitles",
			},
		}
	},
	databaseManagement: {
		id: "databaseManagement",
		text: "工具",
		path: "meeting/databaseManagement",
		icon: "KeyboardAlt",
		subMenu: {
			databaseBackup: {
				id: "databaseBackup",
				text: "数据库备份",
				path: "meeting/databaseManagement/database-backup",
				icon: "WifiProtectedSetup",
			},
			databaseReduction: {
				id: "databaseReduction",
				text: "数据库还原",
				path: "meeting/databaseManagement/database-reduction",
				icon: "WrapText",
			},
		}
	},
	repairCenter: {
		id: "repair-center",
		text: "紧急报修",
		path: "repair-center",
		icon: "Announcement",
		subMenu: null,
	},
	about: {
		id: "about",
		text: "关于",
		path: "meeting/about",
		icon: "Dashboard",
		subMenu: null,
	},
};


// 无纸化会议系统
export const paperlessPages = {
	pages: {
		id: "paperless",
		text: "无纸化会议系统",
		icon: "FileCopy",
	},
	meetingList: {
		id: "meetingList",
		text: "会议列表",
		path: "paperless/meetingList",
		icon: "AccessAlarm",
		subMenu: {
			notCompletedMeeting: {
				id: "notCompletedMeeting",
				text: "未完成会议列表",
				path: "paperless/meetingList/notCompletedMeeting",
				icon: "EditCalendar",
				notification: true,
			},
			appointmentMeeting: {
				id: "appointmentMeeting",
				text: "会议预约管理",
				path: "paperless/meetingList/appointmentMeeting",
				icon: "AccessAlarm",
				notification: true,
			},
			archivedMeeting: {
				id: "archivedMeeting",
				text: "已归档会议列表",
				path: "paperless/meetingList/archivedMeeting",
				icon: "WifiProtectedSetup",
			},
			templateMeeting: {
				id: "templateMeeting",
				text: "会议模板列表",
				path: "paperless/meetingList/templateMeeting",
				icon: "CalendarViewMonth",
			},
		}
	},
	personalAdministration: {
		id: "personalAdministration",
		text: "人事管理",
		path: "paperless/personalAdministration",
		icon: "Article",
		subMenu: {
			passwordManagement: {
				id: "passwordManagement",
				text: "密码管理",
				path: "paperless/personalAdministration/passwordManagement",
				icon: "EditCalendar",
			},
			personnelManagement: {
				id: "personnelManagement",
				text: "人员管理",
				path: "paperless/personalAdministration/personnelManagement",
				icon: "Group",
			},
			userGroupManagement: {
				id: "userGroupManagement",
				text: "用户组管理",
				path: "paperless/personalAdministration/userGroupManagement",
				icon: "Podcasts",
				hide: true,
			},
			departmentManagement: {
				id: "departmentManagement",
				text: "部门管理",
				path: "paperless/personalAdministration/departmentManagement",
				icon: "Schema",
			},
			administratorList: {
				id: "administratorList",
				text: "管理员列表",
				path: "paperless/personalAdministration/administratorList",
				icon: "AccessAlarm",
			},
			userSearch: {
				id: "userSearch",
				text: "用户搜索",
				path: "paperless/personalAdministration/userSearch",
				icon: "FileCopy",
			},
		}
	},
	systemSettings: {
		id: "systemSettings",
		text: "系统设置",
		path: "paperless/systemSettings",
		icon: "Radio",
		subMenu: {
			installListManage: {
				id: "installListManage",
				text: "安装包管理",
				path: "paperless/systemSettings/installListManage",
				icon: "ViewArray",
			},
			installationPackageManagement: {
				id: "installationPackageManagement",
				text: "安装包上传",
				path: "paperless/systemSettings/installationPackageManagement",
				icon: "ViewArray",
			},
			permissionManagement: {
				id: "permissionManagement",
				text: "权限管理",
				path: "paperless/systemSettings/permissionManagement",
				icon: "ViewArray",
			},
			addPermission: {
				id: "permissionManagement",
				text: "添加权限",
				path: "paperless/systemSettings/addPermission",
				icon: "ViewArray",
			},
			websiteEditing: {
				id: "websiteEditing",
				text: "网站编辑",
				path: "paperless/systemSettings/websiteEditing",
				icon: "ViewArray",
			},
			deviceManagement: {
				id: "deviceManagement",
				text: "设备管理",
				path: "paperless/systemSettings/deviceManagement",
				icon: "ViewArray",
			},
			apDevicesManagement: {
				id: "apDevicesManagement",
				text: "AP设备管理",
				path: "paperless/systemSettings/apDevicesManagement",
				icon: "ViewArray",
			},
			inkscreenManagement: {
				id: "inkscreenManagement",
				text: "墨水屏设备管理",
				path: "paperless/systemSettings/inkscreenManagement",
				icon: "ViewArray",
			},
			inkscreenTemplateManagement: {
				id: "inkscreenTemplateManagement",
				text: "墨水屏模板管理",
				path: "paperless/systemSettings/inkscreenTemplateManagement",
				icon: "ViewArray",
			},
			inkscreenTemplateAdd: {
				id: "inkscreenTemplateAdd",
				text: "添加墨水屏模板",
				path: "paperless/systemSettings/inkscreenTemplateAdd",
				hide: true,
			},
			inkscreenTemplateEdit: {
				id: "inkscreenTemplateEdit",
				text: "编辑墨水屏模板",
				path: "paperless/systemSettings/inkscreenTemplateEdit",
				hide: true,
			},
			meetingRoomManagement: {
				id: "meetingRoomManagement",
				text: "会议室管理",
				path: "paperless/systemSettings/meetingRoomManagement",
				icon: "Store",
			},
			menuManagement: {
				id: "menuManagement",
				text: "菜单管理",
				path: "paperless/systemSettings/menuManagement",
				icon: "Rule",
			},
			callServiceManagement: {
				id: "callServiceManagement",
				text: "呼叫服务管理",
				path: "paperless/systemSettings/callServiceManagement",
				icon: "Rule",
				hide: true,
			},
			tableStyleManagement: {
				id: "tableStyleManagement",
				text: "桌牌样式管理",
				path: "paperless/systemSettings/tableStyleManagement",
				icon: "Rule",
			},
			votingTemplateManagement: {
				id: "votingTemplateManagement",
				text: "表决模板管理",
				path: "paperless/systemSettings/votingTemplateManagement",
				icon: "ViewArray",
			},
			androidConfigurationPage: {
				id: "androidConfigurationPage",
				text: "android配置页面",
				path: "paperless/systemSettings/androidConfigurationPage",
				icon: "Rule",
				hide: true,
			},
			clientMenuManagement: {
				id: "clientMenuManagement",
				text: "客户端菜单管理",
				path: "paperless/systemSettings/clientMenuManagement",
				icon: "Rule",
			},
			importData: {
				id: "importData",
				text: "导入数据",
				path: "paperless/systemSettings/importData",
				icon: "Rule",
				hide: true,
			},
			userOperationLog: {
				id: "userOperationLog",
				text: "用户操作日志",
				path: "paperless/systemSettings/userOperationLog",
				icon: "Summarize",
			},
			communicationServiceManagement: {
				id: "communicationServiceManagement",
				text: "通信服务管理",
				path: "paperless/systemSettings/communicationServiceManagement",
				icon: "Rule",
			},
			winManagement: {
				id: "winManagement",
				text: "win程序管理",
				path: "paperless/systemSettings/winManagement",
				icon: "ViewArray",
				hide: true,
			},
			seatManagement: {
				id: "seatManagement",
				text: "座位管理",
				path: "paperless/systemSettings/seatManagement",
				icon: "Roofing",
			},
			tableInstallationManagement: {
				id: "tableInstallationManagement",
				text: "桌牌安装包管理",
				path: "paperless/systemSettings/tableInstallationManagement",
				icon: "Rule",
				hide: true,
			},
			historicalConferenceManagement: {
				id: "historicalConferenceManagement",
				text: "历史会议管理",
				path: "paperless/systemSettings/historicalConferenceManagement",
				icon: "ViewArray",
				hide: true,
			},
			waterSignInstallationManagement: {
				id: "waterSignInstallationManagement",
				text: "水牌安装包管理",
				path: "paperless/systemSettings/waterSignInstallationManagement",
				icon: "Rule",
				hide: true,
			},
			largeScreenProgramManagement: {
				id: "largeScreenProgramManagement",
				text: "大屏程序管理",
				path: "paperless/systemSettings/largeScreenProgramManagement",
				icon: "Rule",
				hide: true,
			},
			backupSettings: {
				id: "backupSettings",
				text: "备份设置",
				path: "paperless/systemSettings/backupSettings",
				icon: "ViewArray",
			},
			speechRecognitionConfiguration: {
				id: "speechRecognitionConfiguration",
				text: "语音识别词语配置",
				path: "paperless/systemSettings/speechRecognitionConfiguration",
				icon: "ViewArray",
				hide: true,
			},
		}
	},
	issueManagement:  {
		id: "issueManagement",
		text: "议题管理",
		path: "paperless/issueManagement",
		icon: "Article",
		hide: true,
		subMenu: {
			unauditedTopicList: {
				id: "unauditedTopicList",
				text: "未审核议题列表",
				path: "paperless/issueManagement/unauditedTopicList",
				icon: "EditCalendar",
				hide: true,
			},
			approvedTopicList: {
				id: "approvedTopicList",
				text: "已审核议题列表",
				path: "paperless/issueManagement/approvedTopicList",
				icon: "AccessAlarm",
				hide: true,
			},
		}
	},
	knowledgeManagement: {
		id: "knowledgeManagement",
		text: "资料库",
		path: "paperless/knowledgeManagement",
		icon: "Article",
		subMenu: {
			publicDatabase: {
				id: "publicDatabase",
				text: "公共资料库",
				path: "paperless/knowledgeManagement/publicDatabase",
				icon: "ViewArray",
			}
		}
	},
	fileUpload:  {
		id: "fileUpload",
		text: "多文件上传",
		path: "paperless/fileUpload",
		icon: "Article",
		hide: true,
	},
	userManagement:  {
		id: "userManagement",
		text: "用户管理",
		path: "paperless/userManagement",
		icon: "Group",
	},
	toolManagement:  {
		id: "toolManagement",
		text: "工具管理",
		path: "paperless/toolManagement",
		icon: "KeyboardAlt",
		hide: true,
	},
};
// 腾讯会议系统
export const tencentHyPages = {
	pages: {
		id: "tencentHy",
		text: "无纸化会议系统",
		icon: "FileCopy",
	},
	meetingList: {
		id: "meetingList",
		text: "会议列表",
		path: "tencentHy/meetingList",
		icon: "AccessAlarm",
		subMenu: {
			notCompletedMeeting: {
				id: "notCompletedMeeting",
				text: "未完成会议列表",
				path: "tencentHy/meetingList/notCompletedMeeting",
				icon: "EditCalendar",
				notification: true,
			},
			archivedMeeting: {
				id: "archivedMeeting",
				text: "已归档会议列表",
				path: "tencentHy/meetingList/archivedMeeting",
				icon: "WifiProtectedSetup",
			},
			templateMeeting: {
				id: "templateMeeting",
				text: "会议模板列表",
				path: "tencentHy/meetingList/templateMeeting",
				icon: "CalendarViewMonth",
			},
		},
		_details:{
			id: "meetingList",
			text: "会议详情",
			path: "tencentHy/meetingList/_details",
			icon: "AccessAlarm",
			subMenu: {
				MeetingDetails: {
					id: "MeetingDetails",
					text: "会议详情模块",
					path: "tencentHy/meetingList/_details/meetingDetails/:id",
					icon: "CalendarViewMonth",
				},
			}
		}
	},
	statementManagement: {
		id: "statementManagement",
		text: "会议列表",
		path: "tencentHy/statementManagement",
		icon: "AccessAlarm",
		subMenu: {
			MeetingSignature: {
				id: "MeetingSignature",
				text: "签到列表",
				path: "tencentHy/statementManagement/MeetingSignature",
				icon: "EditCalendar",
				notification: true,
			},
		}
	},
};
// 其他路由
export const layoutMenu = {
	login: {
		id: 'login',
		text: 'Login',
		path: '/login',
		icon: 'Login',
	},
	page404: {
		id: 'Page404',
		text: '404 Page',
		path: '*',
		icon: 'ReportGmailerrorred',
	},
};

export const dashboardMenu = {
	dashboard: {
		id: "dashboard-booking",
		text: "办公空间可视化",
		path: "/",
		icon: "emoji_transportation",
		subMenu: null,
	},
	digitalTwin: {
		id: "digital-twin",
		text: "办公空间数字孪生",
		path: "digital-twin",
		icon: "Apartment",
		subMenu: null,
	},
	eventCenter: {
		id: "event-center",
		text: "事件中心",
		path: "event-center",
		icon: "Event",
		subMenu: null,
	},
	noticeCenter: {
		id: "notice-center",
		text: "通知中心",
		path: "notice-center",
		icon: "Announcement",
		subMenu: null,
	},
	summary: {
		id: "summary",
		text: "Summary",
		path: "summary",
		icon: "sticky_note_2",
		subMenu: null,
	},
};

export const demoPages = {
	pages: {
		id: "pages",
		text: "Pages",
		icon: "Extension",
	},
	singlePages: {
		id: "singlePages",
		text: "Single Pages",
		path: "single-pages",
		icon: "Article",
		subMenu: {
			boxedSingle: {
				id: "boxedSingle",
				text: "Boxed",
				path: "single-pages/boxed",
				icon: "ViewArray",
			},
			fluidSingle: {
				id: "fluidSingle",
				text: "Fluid",
				path: "single-pages/fluid",
				icon: "ViewDay",
			},
		},
	},
	listPages: {
		id: "listPages",
		text: "List Pages",
		path: "list-pages",
		icon: "Dvr",
		subMenu: {
			listBoxed: {
				id: "listBoxed",
				text: "Boxed List",
				path: "list-pages/boxed-list",
				icon: "ViewArray",
			},
			listFluid: {
				id: "listFluid",
				text: "Fluid List",
				path: "list-pages/fluid-list",
				icon: "ViewDay",
			},
		},
	},
	gridPages: {
		id: "gridPages",
		text: "Grid Pages",
		path: "grid-pages",
		icon: "Window",
		subMenu: {
			gridBoxed: {
				id: "gridBoxed",
				text: "Boxed Grid",
				path: "grid-pages/boxed",
				icon: "ViewArray",
			},
			gridFluid: {
				id: "gridFluid",
				text: "Fluid Grid",
				path: "grid-pages/fluid",
				icon: "ViewDay",
			},
		},
	},
	editPages: {
		id: "editPages",
		text: "Edit Pages",
		path: "edit-pages",
		icon: "drive_file_rename_outline ",
		subMenu: {
			editModern: {
				id: "editModern",
				text: "Modern Edit",
				path: "edit-pages/modern",
				icon: "AutoAwesomeMosaic",
				notification: "primary",
			},
			editBoxed: {
				id: "editBoxed",
				text: "Boxed Edit",
				path: "edit-pages/boxed",
				icon: "ViewArray",
			},
			editFluid: {
				id: "editFluid",
				text: "Fluid Edit",
				path: "edit-pages/fluid",
				icon: "ViewDay",
			},
			editWizard: {
				id: "editWizard",
				text: "Wizard Edit",
				path: "edit-pages/wizard",
				icon: "LinearScale",
			},
			editInCanvas: {
				id: "editInCanvas",
				text: "In Canvas Edit",
				path: "edit-pages/in-canvas",
				icon: "VerticalSplit",
			},
			editInModal: {
				id: "editInModal",
				text: "In Modal Edit",
				path: "edit-pages/in-modal",
				icon: "PictureInPicture",
			},
		},
	},
	pricingTable: {
		id: "pricingTable",
		text: "Pricing Table",
		path: "pricing-table",
		icon: "Local Offer",
	},

	auth: {
		id: "auth",
		text: "Auth Pages",
		icon: "Extension",
	},
	login: {
		id: "login",
		text: "Login",
		path: "auth-pages/login",
		icon: "Login",
	},
	editPassword: {
		id: "editPassword",
		text: "重置密码",
		path: "auth-pages/edit-password",
		icon: "Login"
	},
	empowerPage: {
		id: "empowerPage",
		text: "授权页",
		path: "auth-pages/empower",
		icon: "Login"
	},
	signUp: {
		id: "signUp",
		text: "Sign Up",
		path: "auth-pages/sign-up",
		icon: "PersonAdd",
	},
	employeeID: {
		id: "employeeID",
		text: "employeeID",
		path: "appointment/employee",
		hide: true,
	},
	page404: {
		id: "Page404",
		text: "404 Page",
		path: "auth-pages/404",
		icon: "ReportGmailerrorred",
	},

	app: {
		id: "app",
		text: "Apps",
		icon: "Extension",
	},
	appointment: {
		id: "appointment",
		text: "Appointment",
		path: "appointment",
		icon: "Today",
		subMenu: {
			// dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "预约会议",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			appointmentList: {
				id: "appointmentList",
				text: "我的会议",
				path: "appointment/appointment-list",
				icon: "Event",
			},
			meetingManagement: {
				id: "meetingManagement",
				text: "会议管理",
				path: "appointment/meeting-management",
				icon: "Event",
			},
		},
	},
	meetingRoom: {
		id: "meetingRoom",
		text: "MeetingRoom",
		path: "appointment",
		icon: "Today",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "Calendar",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			employeeList: {
				id: "employeeList",
				text: "Employee List",
				path: "appointment/employee-list",
				icon: "PersonSearch",
			},
			employeeID: {
				id: "employeeID",
				text: "employeeID",
				path: "appointment/employee",
				hide: true,
			},
			employee: {
				id: "employee",
				text: "Employee",
				path: "appointment/employee/1",
				icon: "QrCode2",
			},
			appointmentList: {
				id: "appointmentList",
				text: "Appointment List",
				path: "appointment/appointment-list",
				icon: "Event",
			},
		},
	},
	deviceAsset: {
		id: "deviceAsset",
		text: "DeviceAsset",
		path: "appointment",
		icon: "Today",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "Calendar",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			employeeList: {
				id: "employeeList",
				text: "Employee List",
				path: "appointment/employee-list",
				icon: "PersonSearch",
			},
			employeeID: {
				id: "employeeID",
				text: "employeeID",
				path: "appointment/employee",
				hide: true,
			},
			employee: {
				id: "employee",
				text: "Employee",
				path: "appointment/employee/1",
				icon: "QrCode2",
			},
			appointmentList: {
				id: "appointmentList",
				text: "Appointment List",
				path: "appointment/appointment-list",
				icon: "Event",
			},
		},
	},
	energyManagement: {
		id: "energyManagement",
		text: "EnergyManagement",
		path: "appointment",
		icon: "Today",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "Calendar",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			employeeList: {
				id: "employeeList",
				text: "Employee List",
				path: "appointment/employee-list",
				icon: "PersonSearch",
			},
			employeeID: {
				id: "employeeID",
				text: "employeeID",
				path: "appointment/employee",
				hide: true,
			},
			employee: {
				id: "employee",
				text: "Employee",
				path: "appointment/employee/1",
				icon: "QrCode2",
			},
			appointmentList: {
				id: "appointmentList",
				text: "Appointment List",
				path: "appointment/appointment-list",
				icon: "Event",
			},
		},
	},
	signageManagement: {
		id: "signageManagement",
		text: "SignageManagement",
		path: "appointment",
		icon: "Today",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "Calendar",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			employeeList: {
				id: "employeeList",
				text: "Employee List",
				path: "appointment/employee-list",
				icon: "PersonSearch",
			},
			employeeID: {
				id: "employeeID",
				text: "employeeID",
				path: "appointment/employee",
				hide: true,
			},
			employee: {
				id: "employee",
				text: "Employee",
				path: "appointment/employee/1",
				icon: "QrCode2",
			},
			appointmentList: {
				id: "appointmentList",
				text: "Appointment List",
				path: "appointment/appointment-list",
				icon: "Event",
			},
		},
	},
	digitalTwinManagement: {
		id: "digitalTwinManagement",
		text: "DigitalTwinManagement",
		path: "appointment",
		icon: "Today",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			calendar: {
				id: "calendar",
				text: "Calendar",
				path: "appointment/calendar",
				icon: "EditCalendar",
				notification: true,
			},
			employeeList: {
				id: "employeeList",
				text: "Employee List",
				path: "appointment/employee-list",
				icon: "PersonSearch",
			},
			employeeID: {
				id: "employeeID",
				text: "employeeID",
				path: "appointment/employee",
				hide: true,
			},
			employee: {
				id: "employee",
				text: "Employee",
				path: "appointment/employee/1",
				icon: "QrCode2",
			},
			appointmentList: {
				id: "appointmentList",
				text: "Appointment List",
				path: "appointment/appointment-list",
				icon: "Event",
			},
		},
	},
	projectManagement: {
		id: "projectManagement",
		text: "Project Management",
		path: "project-management",
		icon: "AutoStories",
		subMenu: {
			list: {
				id: "list",
				text: "Projects",
				path: "project-management/list",
				icon: "AutoStories",
			},
			itemID: {
				id: "projectID",
				text: "projectID",
				path: "project-management/project",
				hide: true,
			},
			item: {
				id: "item",
				text: "Project",
				path: "project-management/project/1",
				icon: "Book",
			},
		},
	},
	knowledge: {
		id: "knowledge",
		text: "Knowledge",
		path: "knowledge",
		icon: "AutoStories",
		subMenu: {
			grid: {
				id: "grid",
				text: "Knowledge Grid",
				path: "knowledge/grid",
				icon: "AutoStories",
			},
			itemID: {
				id: "itemID",
				text: "itemID",
				path: "knowledge/item",
				hide: true,
			},
			item: {
				id: "item",
				text: "Item",
				path: "knowledge/item/1",
				icon: "Book",
			},
		},
	},
	sales: {
		id: "sales",
		text: "Sales",
		path: "sales",
		icon: "Store",
		subMenu: {
			dashboard: dashboardMenu.dashboard,
			salesList: {
				id: "products",
				text: "Sales List",
				path: "sales/sales-list",
				icon: "FactCheck",
			},
			productsGrid: {
				id: "productsGrid",
				text: "Products Grid",
				path: "sales/grid",
				icon: "CalendarViewMonth",
			},
			productID: {
				id: "productID",
				text: "productID",
				path: "sales/product",
				hide: true,
			},
			product: {
				id: "product",
				text: "Product",
				path: "sales/product/1",
				icon: "QrCode2",
			},
			transactions: {
				id: "transactions",
				text: "Transactions",
				path: "sales/transactions",
				icon: "PublishedWithChanges",
			},
		},
	},
	crm: {
		id: "crm",
		text: "CRM",
		path: "crm",
		icon: "Contacts",
		subMenu: {
			dashboard: {
				id: "dashboard",
				text: "CRM Dashboard",
				path: "crm/dashboard",
				icon: "RecentActors",
			},
			customersList: {
				id: "customersList",
				text: "Customers",
				path: "crm/customers",
				icon: "PersonSearch",
			},
			customerID: {
				id: "customerID",
				text: "customerID",
				path: "crm/customer",
				hide: true,
			},
			customer: {
				id: "customer",
				text: "Customer",
				path: "crm/customer/1",
				icon: "Badge",
			},
			// sales: {
			// 	id: "sales",
			// 	text: "Sales",
			// 	path: "crm/sales",
			// 	icon: "Storefront",
			// },
			// invoiceID: {
			// 	id: "invoiceID",
			// 	text: "invoiceID",
			// 	path: "crm/invoice",
			// 	hide: true,
			// },
			// invoice: {
			// 	id: "invoice",
			// 	text: "Invoice",
			// 	path: "crm/invoice/1",
			// 	icon: "Receipt",
			// },
		},
	},
	chat: {
		id: "chat",
		text: "Chat",
		path: "chat",
		icon: "Forum",
		subMenu: {
			withListChat: {
				id: "withListChat",
				text: "With List",
				path: "chat/with-list",
				icon: "Quickreply",
			},
			onlyListChat: {
				id: "onlyListChat",
				text: "Only List",
				path: "chat/only-list",
				icon: "Dns",
			},
		},
	},
};



// 墨水屏应用
export const inkScreenPages = {
	// pages: {
	// 	id: "inkScreen",
	// 	text: "墨水屏应用",
	// 	icon: "Extension",
	// },
	refreshWifiHome: {
		id: "refreshWifiHome",
		text: "Wifi设备刷新",
		path: "/inkScreen/refreshWifiHome",
		icon: "ti-rss-alt",
		subMenu: null,
	},
	refreshHome: {
		id: "refreshHome",
		text: "蓝牙设备刷新",
		path: "/inkScreen/refreshHome",
		icon: "ti-rss",
	},
	modelHome: {
		id: "modelHome",
		text: "模板管理",
		path: "/inkScreen/modelHome",
		icon: "ti-layout",
	},
	zpWifiHome: {
		id: "zpWifiHome",
		text: "Wifi设备",
		path: "/inkScreen/zpWifiHome",
		icon: "ti-harddrive",
	},
	myZpHome: {
		id: "myZpHome",
		text: "蓝牙设备",
		path: "/inkScreen/myZpHome",
		icon: "ti-harddrives",
	},
	zpHome: {
		id: "zpHome",
		text: "扫描设备",
		path: "/inkScreen/zpHome",
		icon: "ti-harddrives",
	},
	apHome: {
		id: "apHome",
		text: "AP设备",
		path: "/inkScreen/apHome",
		icon: "ti-package",
	},
};